import { observer } from "mobx-react-lite";
import { usePopupStore } from "..";
import useNavigateToProperty from "../hooks/useNavigateToProperty";
import ILead from "../interfaces/ILead";
import PopupType from "../interfaces/PopupType";
import { leadStatusToString } from "../utils/enumUtils";
import { formatDate, formatNumber, formatPrice } from "../utils/utils";
import commonStyles from "./Common.module.css";
import Grid, { IHeader } from "./Grid";

function RecordedSalesGrid({ recordedSales, additionalHeaders, radiusDropdown }: IRecordedSalesGridProps) {
    const popupStore = usePopupStore();
    const navigateToProperty = useNavigateToProperty();

    return (
        <Grid
            data={recordedSales}
            headers={[
                {
                    align: "left",
                    titleStrings: ["OWNER NAME"],
                    getValue: item => item.ownerName,
                    getLabel: item => item.ownerName || "",
                },
                {
                    align: "left",
                    isFullWidth: true,
                    titleStrings: ["ADDRESS"],
                    getValue: item => item.address,
                    getLabel: item => item.address || "",
                },
                {
                    titleStrings: ["STATUS"],
                    getValue: item => item.status,
                    getLabel: item => leadStatusToString(item.status),
                },
                {
                    titleStrings: ["ZONING"],
                    getValue: item => item.zoning,
                    getLabel: item => item.zoning || "",
                },
                {
                    titleStrings: ["BUILDING", "SIZE"],
                    getValue: item => item.buildingSize,
                    getLabel: item => item.buildingSize ? formatNumber(item.buildingSize) : "",
                },
                {
                    titleStrings: ["LAND", "SIZE"],
                    getValue: item => item.landSize,
                    getLabel: item => item.landSize ? formatNumber(item.landSize) : "",
                },
                {
                    titleStrings: ["LOT", "COVERAGE"],
                    getValue: item => item.lotCoverage,
                    getLabel: item => item.lotCoverage ? `${item.lotCoverage}%` : "",
                },
                {
                    titleStrings: ["SALE PRICE"],
                    getValue: item => item.salePrice,
                    getLabel: item => item.salePrice ? formatPrice(item.salePrice) : "",
                },
                {
                    titleStrings: ["SALE DATE"],
                    getValue: item => item.saleDate,
                    getLabel: item => item.saleDate ? formatDate(item.saleDate) : "",
                },
                ...additionalHeaders || [],
            ]}
            getId={item => item.id}
            downloadFileName={"RecordedSales"}
            onRowClick={item => navigateToProperty(item.centerPoint.longitude, item.centerPoint.latitude)}
            isRowActive={item => popupStore.type === PopupType.Property && popupStore.longitude === item.centerPoint.longitude && popupStore.latitude === item.centerPoint.latitude}
            header={
                <div className={[commonStyles.gridTitle, commonStyles.header].join(" ")}>
                    {recordedSales.length} Recorded Sales
                    {radiusDropdown}
                </div>
            }
        />
    );
}

export default observer(RecordedSalesGrid);

interface IRecordedSalesGridProps {
    recordedSales: ILead[];
    additionalHeaders?: IHeader<ILead>[];
    radiusDropdown?: React.ReactNode;
}